// @flow
import {
  ME_UPDATE,
  ME_UNAUTHORIZED,
  SETTINGS_SAVED,
  SETTINGS_SAVING
} from '../actions/user.actions';

const initialState = {
  unknown: true
};

export default (
  state: Object = initialState,
  action: { type: String, data: Object, idx: number }
) => {
  switch (action.type) {
    case SETTINGS_SAVING:
      return {
        ...state,
        saveSettings: true
      };
    case SETTINGS_SAVED:
      return {
        ...state,
        saveSettings: false
      };
    case ME_UPDATE:
      const user = action.data;
      return {
        ...state,
        unknown: false,
        user
      };
    case ME_UNAUTHORIZED:
      return {
        ...state,
        unknown: false,
        user: undefined
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/meReducer.js